import React, { Component } from "react";
import PropTypes from "prop-types";
import FilledStar from "../resources/FilledStar.png";
import EmptyStar from "../resources/EmptyStar.png";
class StarRating extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rating: 0,
      tmpRating: 0
    };
    this.onMouseOver = this.onMouseOver.bind(this);
    this.onMouseOut = this.onMouseOut.bind(this);
    this.onClick = this.onClick.bind(this);
  }
  onMouseOver(e) {
    this.setState({
      tmpRating: e.target.attributes.getNamedItem("data-rating").value
    });
  }
  onMouseOut() {
    this.setState({
      tmpRating: 0
    });
  }
  onClick(e) {
    this.setState({
      rating: e.target.attributes.getNamedItem("data-rating").value
    });
    this.props.onChange(e.target.attributes.getNamedItem("data-rating").value);
  }
  render() {
    const ratings = [1, 2, 3, 4, 5];
    const currentRating = this.state.tmpRating > 0 ? this.state.tmpRating : this.state.rating;
    return /*#__PURE__*/React.createElement("div", {
      id: "star-rating"
    }, ratings.map(rating => {
      return /*#__PURE__*/React.createElement("div", {
        className: "star-wrapper",
        onMouseOver: this.onMouseOver,
        onMouseOut: this.onMouseOut,
        onClick: this.onClick,
        "data-rating": rating,
        key: rating
      }, /*#__PURE__*/React.createElement("img", {
        alt: "Rating Star",
        src: rating > currentRating ? EmptyStar : FilledStar,
        "data-rating": rating
      }));
    }));
  }
}
StarRating.propTypes = {
  onChange: PropTypes.func
};
export default StarRating;